export const ourValuesSecuritySlider = () => {
  (function ($) {
    
    if($('#ourValuesSecuritySlider').length === 0) {
      return;
    }

    const slider = $('#ourValuesSecuritySlider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      adaptiveHeight: true,
      waitForAnimate: false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            dots: true,
            arrows: false,
          }
        },

        {
          breakpoint: 966,
          settings: {
            dots: true,
            arrows: false,
            infinite: true
          }
        },
      ]
    })


    
    // tab button

    if($('.our-values__btn').length === 0) {
      return;
    }

    // set default active button
    $('.our-values__btn[data-slide=0]').addClass('our-values__btn--active');

    // when change slide, button also change
    slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        let button = $(`.our-values__btn[data-slide=${currentSlide}]`);
        $('.our-values__btn').removeClass('our-values__btn--active');
        if (!button.hasClass('our-values__btn--active')) {
            button.addClass('our-values__btn--active');
        }
    });

    $(document).on('click', '.our-values__btn', function () {
        slider.slick('slickGoTo', $(this).data('slide'));

        $('.our-values__btn').removeClass('our-values__btn--active');

        if (!$(this).hasClass('our-values__btn--active')) {
            $(this).addClass('our-values__btn--active');
        }
        
    })


  })(jQuery);
}